"use client"

import { useEffect, useState, useMemo } from "react"
import { Search, UserPlus, ChevronDown, Edit, Key, Trash2, ChevronLeft, ChevronRight, ChevronsLeft, ChevronsRight, ShieldCheck } from 'lucide-react'
import { Button } from "../components/ui/button"
import { Input } from "../components/ui/input"
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "../components/ui/table"
import { Avatar, AvatarImage } from "../components/ui/avatar"
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "../components/ui/dropdown-menu"
import { AddUserModal } from "../components/add-user-modal"
import { EditUserModal } from "../components/edit-user-modal"
import { ChangePasswordModal } from "../components/change-password-modal"
import { DeleteUserModal } from '../components/delete-user-modal'
import { RoleManagementModal } from "../components/role-management-modal"
import { isAdminRole } from "../constants/roles"
import { userManagementService } from "../apis/userManagement";
import noprofile from "../asset/img/noprofile.webp"
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import toast from "react-hot-toast";

export default function UserManagementPage() {
  const [users, setUsers] = useState([])
  const [searchTerm, setSearchTerm] = useState("")
  const [currentPage, setCurrentPage] = useState(1)
  const [entriesPerPage, setEntriesPerPage] = useState(5)
  const [sortConfig, setSortConfig] = useState({ key: null, direction: "ascending" })
  const [roles, setRoles] = useState([])
  const [loading, setLoading] = useState(true)
  const base64Logo = 'data:image/png;base64,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'
  // Modal states
  const [isAddUserModalOpen, setIsAddUserModalOpen] = useState(false)
  const [isEditUserModalOpen, setIsEditUserModalOpen] = useState(false)
  const [isChangePasswordModalOpen, setIsChangePasswordModalOpen] = useState(false)
  const [isDeleteDialogOpen, setIsDeleteDialogOpen] = useState(false)
  const [isRoleModalOpen, setIsRoleModalOpen] = useState(false)
  const [selectedUser, setSelectedUser] = useState(null)

  const currentUser = useMemo(() => {
    try {
      return JSON.parse(localStorage.getItem("user") || "{}");
    } catch {
      return {};
    }
  }, []);

  const isAdmin = !currentUser?.role || isAdminRole(currentUser?.role);

  const handleRolesUpdated = async () => {
    try {
      const rolesRes = await userManagementService.getRoles();
      if (rolesRes.success && rolesRes?.data?.body?.data) {
        setRoles(rolesRes.data.body.data);
      }
    } catch (err) {
      console.error("Error refreshing roles:", err);
    }
  };

  useEffect(() => {
    const fetchAll = async () => {
      setLoading(true)
      try {
        const [usersRes, rolesRes] = await Promise.all([
          userManagementService.getAllUsers(),
          userManagementService.getRoles(),
          userManagementService.getEnabledMailUsers()
        ]);
        if(usersRes.success && usersRes?.data?.body?.data) {
          const mappedUsers = usersRes.data.body.data.map(user => ({
            id: user.userid || user.id,
            name: user.name,
            email: user.emailid,
            phone: user.phoneno,
            role: user.role,
            lastLogin: user.lastLoginAgo || 'Never',
            mailStatus: user.mail_status === 'enabled' ? 'Enabled' : 'Disabled',
            profileImage: user?.profileimage || "https://cdn.pixabay.com/photo/2023/02/18/11/00/icon-7797704_640.png" || user?.profileImagePath || "/assets/noprofile.webp",
            // Keep original data for reference
            originalData: user
          }))
          setUsers(mappedUsers);
        } else {
          console.error("Users error:", usersRes?.message || "Failed to fetch users");
          setUsers([]);
        }

        if (rolesRes.success && rolesRes?.data?.body?.data) {
          setRoles(rolesRes.data.body.data);
        } else {
          console.error("Roles error:", rolesRes?.message || "Failed to fetch roles");
          setRoles([]);
        }

      } catch (error) {
        console.error("Error fetching data:", error);
        setUsers([]);
        setRoles([]);
      } finally {
        setLoading(false);
      }
    };

    fetchAll();
  }, []);

  // Handle search with safe checks
  const filteredUsers = users.filter((user) => {
    if (!user) return false;
    const name = user.name || '';
    const email = user.email || '';
    const phone = user.phone || '';
    const role = user.role || '';

    return (
      name.toLowerCase().includes(searchTerm.toLowerCase()) ||
      email.toLowerCase().includes(searchTerm.toLowerCase()) ||
      phone.toLowerCase().includes(searchTerm.toLowerCase()) ||
      role.toLowerCase().includes(searchTerm.toLowerCase())
    )
  })

  // Handle sorting with safe checks
  const sortedUsers = [...filteredUsers].sort((a, b) => {
    if (!sortConfig.key) return 0

    const aValue = a[sortConfig.key] || ''
    const bValue = b[sortConfig.key] || ''

    if (aValue < bValue) {
      return sortConfig.direction === "ascending" ? -1 : 1
    }
    if (aValue > bValue) {
      return sortConfig.direction === "ascending" ? 1 : -1
    }
    return 0
  })

  // Handle pagination
  const indexOfLastEntry = currentPage * entriesPerPage
  const indexOfFirstEntry = indexOfLastEntry - entriesPerPage
  const currentEntries = sortedUsers.slice(indexOfFirstEntry, indexOfLastEntry)
  const totalPages = Math.ceil(sortedUsers.length / entriesPerPage)

  // Request sort
  const requestSort = (key) => {
    let direction = "ascending"
    if (sortConfig.key === key && sortConfig.direction === "ascending") {
      direction = "descending"
    }
    setSortConfig({ key, direction })
  }

  const handleEmailStatusChange = async (userId, newStatus) => {
    try {
      // Find the user to get their profile ID
      const user = users.find(u => u.id === userId);
      if (!user) {
        console.error("User not found");
        return;
      }
  
      // Store original status for potential revert
      const originalStatus = user.mailStatus;
  
      // Update local state immediately for better UX
      setUsers(users.map(user =>
        user.id === userId
          ? { ...user, mailStatus: newStatus }
          : user
      ));
  
      // Call API to update the status using profile ID
      const result = await userManagementService.updateMailStatus(user.id, newStatus);
  
      // Check the nested response structure
      const apiResponse = result?.data?.body;
      const isSuccess = result?.success && apiResponse?.message;
  
      if (!isSuccess) {
        // Revert the change if API call fails
        setUsers(users.map(user =>
          user.id === userId
            ? { ...user, mailStatus: originalStatus }
            : user
        ));
        
        const errorMessage = apiResponse?.message || result?.message || 'Unknown error occurred';
        toast.error(`Failed to update email status: ${errorMessage}`);
      } else {
        // Show success message
        toast.success(apiResponse.message || 'Email status updated successfully');
      }
    } catch (error) {
      console.error("Error updating email status:", error);
      
      // Find original status for revert
      const originalUser = users.find(u => u.id === userId);
      const originalStatus = originalUser?.mailStatus === newStatus 
        ? (newStatus === 'Enabled' ? 'Disabled' : 'Enabled') 
        : originalUser?.mailStatus;
      
      // Revert the change if API call fails
      setUsers(users.map(user =>
        user.id === userId
          ? { ...user, mailStatus: originalStatus }
          : user
      ));
      
      toast.error(`Error updating email status: ${error.message || 'Network error occurred'}`);
    }
  };

  // Export to CSV
  const exportToCSV = () => {
    const headers = ["Name", "Email", "Phone", "Role", "Last Login", "Mail Status"]
    const csvData = [
      headers.join(","),
      ...filteredUsers.map((user) =>
        [
          user.name || '',
          user.email || '',
          user.phone || '',
          user.role || '',
          user.lastLogin || '',
          user.mailStatus || ''
        ].join(","),
      ),
    ].join("\n")

    const blob = new Blob([csvData], { type: "text/csv" })
    const url = URL.createObjectURL(blob)
    const link = document.createElement("a")
    link.href = url
    link.download = "user_management.csv"
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
  }

  const exportToPDF = () => {
    try {
      const doc = new jsPDF();

      // Set document properties
      doc.setProperties({
        title: 'User Management Report',
        subject: 'User Management Data',
        author: 'Elite Poker Lounge',
        creator: 'User Management System'
      });

      // Add the logo (base64 image)
      const logoWidth = 40; // adjust width as needed
      const logoHeight = 20; // adjust height as needed
      doc.addImage(base64Logo, 'PNG', 150, 10, logoWidth, logoHeight); // x, y, width, height

      // Add timestamp
      const now = new Date();
      const dateTime = now.toLocaleString('en-US', {
        month: '2-digit',
        day: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: true
      });

      doc.setFontSize(10);
      doc.setTextColor(100);
      doc.text(`Date & Time: ${dateTime}`, 14, 15);

      // Title
      doc.setFontSize(18);
      doc.setTextColor(0);
      doc.setFont(undefined, 'bold');
      doc.text('User Management', 14, 30);

      // Prepare table data
      const tableHeaders = ['Name', 'Email', 'Phone', 'Role', 'Last Login'];
      const tableData = filteredUsers.map(user => [
        user.name || 'N/A',
        user.email || 'N/A',
        user.phone || 'N/A',
        user.role || 'N/A',
        user.lastLogin || 'Never'
      ]);

      // Add table
      autoTable(doc, {
        head: [tableHeaders],
        body: tableData,
        startY: 40,
        theme: 'plain',
        styles: {
          fontSize: 9,
          cellPadding: 3,
          textColor: [0, 0, 0],
          lineColor: [0, 0, 0],
          lineWidth: 0.1
        },
        headStyles: {
          fillColor: false,
          textColor: [0, 0, 0],
          fontStyle: 'bold',
          lineWidth: 0.1,
          lineColor: [0, 0, 0]
        },
        columnStyles: {
          0: { cellWidth: 35 },
          1: { cellWidth: 65 },
          2: { cellWidth: 25 },
          3: { cellWidth: 30 },
          4: { cellWidth: 25 }
        },
        margin: { left: 14, right: 14 },
        tableLineColor: [0, 0, 0],
        tableLineWidth: 0.1
      });

      // Save the PDF
      const fileName = `User_Management_${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-${String(now.getDate()).padStart(2, '0')}.pdf`;
      doc.save(fileName);
    } catch (error) {
      console.error('Error generating PDF:', error);
      toast.error('Error generating PDF. Please try again.');
    }
  };

  // Delete user
  const confirmDeleteUser = (id) => {
    const user = users.find((user) => user.id === id)
    setSelectedUser(user)
    setIsDeleteDialogOpen(true)
  }

  const deleteUser = async () => {
    try {
      // Call API to delete the user
      const result = await userManagementService.deleteUser(selectedUser.id);

      if (result.success) {
        setUsers(users.filter((user) => user.id !== selectedUser.id))
        setIsDeleteDialogOpen(false)
        toast.success(`User ${selectedUser.id} deleted successfully`)
      } else {
        toast.error(`Failed to delete user: ${result.message}`);
      }
    } catch (error) {
      console.error("Error deleting user:", error)
      toast.error(`Error deleting user: ${error.message}`);
    }
  }

  // Edit user
  const editUser = (id) => {
    const user = users.find((user) => user.id === id)
    setSelectedUser(user)
    setIsEditUserModalOpen(true)
  }

  // Change password
  const changePassword = (id) => {
    setSelectedUser(users.find((user) => user.id === id))
    setIsChangePasswordModalOpen(true)
  }

  // Add user
  const addUser = () => {
    setIsAddUserModalOpen(true)
  }

  // Handle add user
  const handleAddUser = async (newUserData) => {
    try {
      const result = await userManagementService.addUser(newUserData);
    
      if (result.success) {
        // Refresh the users list to get the updated data
        const usersRes = await userManagementService.getAllUsers();
        if (usersRes.success && usersRes?.data?.body?.data) {
          const mappedUsers = usersRes.data.body.data.map(user => ({
            id: user.userid || user.id,
            name: user.name,
            email: user.emailid,
            phone: user.phoneno,
            role: user.role,
            lastLogin: user.lastLoginAgo || 'Never',
            mailStatus: user.mail_status === 'enabled' ? 'Enabled' : 'Disabled',
            profileImage: user?.profileimage || "https://cdn.pixabay.com/photo/2023/02/18/11/00/icon-7797704_640.png" || user?.profileImagePath || "/assets/noprofile.webp",
            originalData: user
          }));
          setUsers(mappedUsers);
        }
        toast.success('User added successfully!');
      } else {
        const errorMessage = result?.originalError?.response?.data?.body?.message || result.message;
        toast.error(`${errorMessage}`);
      }
    }catch (error) {
      console.error("Error adding user:", error);
      const errorMessage = error?.response?.data?.body?.message || error.message;
      toast.error(`${errorMessage}`);
    }
    
  }

  // Handle update user
  const handleUpdateUser = async (updatedUserData) => {
    try {
      const result = await userManagementService.updateUser(updatedUserData.id, updatedUserData);

      if (result.success) {
        // Refresh the users list to get the updated data
        const usersRes = await userManagementService.getAllUsers();
        if (usersRes.success && usersRes?.data?.body?.data) {
          const mappedUsers = usersRes.data.body.data.map(user => ({
            id: user.userid || user.id,
            name: user.name,
            email: user.emailid,
            phone: user.phoneno,
            role: user.role,
            lastLogin: user.lastLoginAgo || 'Never',
            mailStatus: user.mail_status === 'enabled' ? 'Enabled' : 'Disabled',
            profileImage: user?.profileimage || "https://cdn.pixabay.com/photo/2023/02/18/11/00/icon-7797704_640.png" || user?.profileImagePath || "/assets/noprofile.webp",
            originalData: user
          }));
          setUsers(mappedUsers);
        }
        toast.success('User updated successfully!');
      } else {
        toast.error(`Failed to update user: ${result.message}`);
      }
    } catch (error) {
      console.error("Error updating user:", error);
      toast.error(`Error updating user: ${error.message}`);
    }
  }

  // Handle change password
  const handleChangePassword = async (userId, passwordData) => {
    try {
      const result = await userManagementService.updatePassword(userId, passwordData);

      if (result.success) {

        toast.success(`Password changed successfully`)
      } else {
        toast.error(`Failed to change password: ${result.message}`);
      }
    } catch (error) {
      console.error("Error changing password:", error)
      toast.error(`Failed to change password: ${error.message}`)
    }
  }

  // Generate pagination buttons
  const renderPaginationButtons = () => {
    const buttons = []

    // Calculate range of pages to show
    let startPage = Math.max(1, currentPage - 2)
    const endPage = Math.min(totalPages, startPage + 4)

    // Adjust start page if we're near the end
    if (endPage - startPage < 4) {
      startPage = Math.max(1, endPage - 4)
    }

    for (let i = startPage; i <= endPage; i++) {
      buttons.push(
        <Button
          key={i}
          variant={currentPage === i ? "default" : "outline"}
          size="icon"
          className="h-8 w-8"
          onClick={() => setCurrentPage(i)}
        >
          {i}
        </Button>,
      )
    }

    return buttons
  }

  if (loading) {
    return (
      <div className="p-6 bg-gray-50 min-h-screen">
        <div className="flex justify-center items-center h-64">
          <div className="animate-spin rounded-full h-12 w-12 border-t-4 border-b-4 border-blue-500"></div>
        </div>
      </div>
    );
  }

  return (
    <div className="p-6 bg-gray-50 min-h-screen">
      <h1 className="text-3xl font-bold text-gray-800 text-center">User Management</h1>

      <div className="flex justify-between items-center mb-6">
        <div className="flex items-center gap-3">
          <Button onClick={addUser} className="bg-yellow-400 hover:bg-yellow-500 text-black">
            <UserPlus className="mr-2 h-4 w-4" />
            Add User
          </Button>

          {isAdmin && (
            <>
              <Button
                onClick={() => setIsRoleModalOpen(true)}
                variant="outline"
                className="border-gray-300 text-gray-800 hover:bg-gray-100 flex items-center gap-2 bg-white"
              >
                <ShieldCheck className="h-4 w-4 text-yellow-600" />
                Manage Roles
              </Button>
            </>
          )}
        </div>

        <div className="flex items-center gap-2">
          <span className="text-sm text-gray-600">Search:</span>
          <div className="relative">
            <Input
              type="text"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="w-64 pl-2 pr-8 py-1 border border-gray-300 rounded"
              placeholder="Search users..."
            />
            <Search className="absolute right-2 top-1/2 transform -translate-y-1/2 h-4 w-4 text-gray-400" />
          </div>

          <Button onClick={exportToCSV} variant="outline" className="ml-2">
            CSV
          </Button>

          <Button onClick={exportToPDF} variant="outline" className="ml-2">
            PDF
          </Button>
        </div>
      </div>

      <div className="bg-white rounded-md shadow overflow-hidden">
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead className="w-[200px] cursor-pointer" onClick={() => requestSort("profileImage")}>
                Profile
                <ChevronDown className="inline-block ml-1 h-4 w-4" />
              </TableHead>
              <TableHead className="cursor-pointer" onClick={() => requestSort("name")}>
                Name
                <ChevronDown className="inline-block ml-1 h-4 w-4" />
              </TableHead>
              <TableHead className="cursor-pointer" onClick={() => requestSort("email")}>
                Email
                <ChevronDown className="inline-block ml-1 h-4 w-4" />
              </TableHead>
              <TableHead className="cursor-pointer" onClick={() => requestSort("phone")}>
                Phone
                <ChevronDown className="inline-block ml-1 h-4 w-4" />
              </TableHead>
              <TableHead className="cursor-pointer" onClick={() => requestSort("role")}>
                Role
                <ChevronDown className="inline-block ml-1 h-4 w-4" />
              </TableHead>
              <TableHead className="cursor-pointer" onClick={() => requestSort("lastLogin")}>
                Last Login
                <ChevronDown className="inline-block ml-1 h-4 w-4" />
              </TableHead>
              <TableHead className="cursor-pointer" onClick={() => requestSort("mailStatus")}>
                Mail Status
                <ChevronDown className="inline-block ml-1 h-4 w-4" />
              </TableHead>
              <TableHead>
                Actions
                <ChevronDown className="inline-block ml-1 h-4 w-4" />
              </TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {currentEntries.length > 0 ? (
              currentEntries.map((user) => (
                <TableRow key={user.id}>
                  <TableCell>
                    <Avatar className="h-12 w-12">
                      <AvatarImage
                        src={user?.profileImage?.trim() ? user.profileImage : noprofile}
                        alt={user?.name || 'User'}
                      /> {/* <AvatarFallback>
                        {user.name ? user.name.charAt(0).toUpperCase() : 'U'}
                      </AvatarFallback> */}
                    </Avatar>
                  </TableCell>
                  <TableCell>{user.name || 'N/A'}</TableCell>
                  <TableCell>{user.email || 'N/A'}</TableCell>
                  <TableCell>{user.phone || 'N/A'}</TableCell>
                  <TableCell>{user.role || 'N/A'}</TableCell>
                  <TableCell>{user.lastLogin || 'Never'}</TableCell>
                  <TableCell className="relative">
                    <DropdownMenu>
                      <DropdownMenuTrigger asChild>
                        <Button
                          variant="outline"
                          size="sm"
                          className={`h-8 px-3 text-xs relative z-10 ${user.mailStatus === 'Enabled'
                              ? 'text-green-700 border-green-200 bg-green-50 hover:bg-green-100'
                              : 'text-red-700 border-red-200 bg-red-50 hover:bg-red-100'
                            }`}
                        >
                          {user.mailStatus || 'Unknown'}
                          <ChevronDown className="ml-1 h-3 w-3" />
                        </Button>
                      </DropdownMenuTrigger>
                      <DropdownMenuContent
                        align="end"
                        className="z-50 min-w-[120px] bg-white border border-gray-200 shadow-lg rounded-md p-1"
                        sideOffset={4}
                      >
                        <DropdownMenuItem
                          onClick={() => handleEmailStatusChange(user.id, 'Enabled')}
                          className="text-green-700 hover:text-green-800 hover:bg-green-50 focus:text-green-800 focus:bg-green-50 cursor-pointer px-2 py-1.5 text-sm rounded-sm transition-colors"
                        >
                          <span className="flex items-center">
                            <div className="w-2 h-2 bg-green-500 rounded-full mr-2"></div>
                            Enabled
                          </span>
                        </DropdownMenuItem>
                        <DropdownMenuItem
                          onClick={() => handleEmailStatusChange(user.id, 'Disabled')}
                          className="text-red-700 hover:text-red-800 hover:bg-red-50 focus:text-red-800 focus:bg-red-50 cursor-pointer px-2 py-1.5 text-sm rounded-sm transition-colors"
                        >
                          <span className="flex items-center">
                            <div className="w-2 h-2 bg-red-500 rounded-full mr-2"></div>
                            Disabled
                          </span>
                        </DropdownMenuItem>
                      </DropdownMenuContent>
                    </DropdownMenu>
                  </TableCell>
                  <TableCell>
                    <div className="flex space-x-1.5 items-center">
                      <Button
                        variant="ghost"
                        size="icon"
                        className="h-8 w-8 text-blue-600"
                        title="Edit User"
                        onClick={() => editUser(user.id)}
                      >
                        <Edit className="h-4 w-4" />
                      </Button>
                      <Button
                        variant="ghost"
                        size="icon"
                        className="h-8 w-8 text-amber-500"
                        title="Change Password"
                        onClick={() => changePassword(user.id)}
                      >
                        <Key className="h-4 w-4" />
                      </Button>
                      <Button
                        variant="ghost"
                        size="icon"
                        className="h-8 w-8 text-red-600"
                        title="Delete User"
                        onClick={() => confirmDeleteUser(user.id)}
                      >
                        <Trash2 className="h-4 w-4" />
                      </Button>
                    </div>
                  </TableCell>
                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell colSpan={8} className="text-center py-4">
                  {searchTerm ? 'No users found matching your search' : 'No users found'}
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </div>

      <div className="flex justify-between items-center mt-4 text-sm">
        <div>
          Showing {filteredUsers.length > 0 ? indexOfFirstEntry + 1 : 0} to{" "}
          {Math.min(indexOfLastEntry, sortedUsers.length)} of {sortedUsers.length} entries
        </div>

        <div className="flex items-center gap-2">
          <select
            value={entriesPerPage}
            onChange={(e) => {
              setEntriesPerPage(Number(e.target.value))
              setCurrentPage(1)
            }}
            className="border border-gray-300 rounded px-2 py-1"
          >
            <option value="5">5</option>
            <option value="10">10</option>
            <option value="25">25</option>
            <option value="50">50</option>
          </select>
          <span>entries per page</span>
        </div>

        <div className="flex items-center gap-1">
          <Button
            variant="outline"
            size="icon"
            className="h-8 w-8"
            onClick={() => setCurrentPage(1)}
            disabled={currentPage === 1}
          >
            <ChevronsLeft className="h-4 w-4" />
          </Button>
          <Button
            variant="outline"
            size="icon"
            className="h-8 w-8"
            onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
            disabled={currentPage === 1}
          >
            <ChevronLeft className="h-4 w-4" />
          </Button>

          {renderPaginationButtons()}

          <Button
            variant="outline"
            size="icon"
            className="h-8 w-8"
            onClick={() => setCurrentPage((prev) => Math.min(prev + 1, totalPages))}
            disabled={currentPage === totalPages}
          >
            <ChevronRight className="h-4 w-4" />
          </Button>
          <Button
            variant="outline"
            size="icon"
            className="h-8 w-8"
            onClick={() => setCurrentPage(totalPages)}
            disabled={currentPage === totalPages}
          >
            <ChevronsRight className="h-4 w-4" />
          </Button>
        </div>
      </div>

      {/* Modals */}
      <AddUserModal
        isOpen={isAddUserModalOpen}
        onClose={() => setIsAddUserModalOpen(false)}
        onAddUser={handleAddUser}
        roles={roles}
      />

      <EditUserModal
        isOpen={isEditUserModalOpen}
        onClose={() => setIsEditUserModalOpen(false)}
        user={selectedUser}
        onUpdateUser={handleUpdateUser}
        roles={roles}
      />

      <ChangePasswordModal
        isOpen={isChangePasswordModalOpen}
        onClose={() => setIsChangePasswordModalOpen(false)}
        userId={selectedUser?.id}
        onChangePassword={handleChangePassword}
      />

      <DeleteUserModal
        isOpen={isDeleteDialogOpen}
        onCancel={() => setIsDeleteDialogOpen(false)}
        onConfirm={deleteUser}
        user={selectedUser}
      />

      <RoleManagementModal
        isOpen={isRoleModalOpen}
        onClose={() => setIsRoleModalOpen(false)}
        onRolesUpdated={handleRolesUpdated}
      />
    </div>
  )
}